import styled from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/lexusTheme";

export const AccessoriesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing-3);
    margin-inline: calc(var(--spacing-2) * -1);
    padding: var(--spacing-2) var(--spacing-2) 0;
    border-top: 1px solid var(--color-platinum-light);

    &:not(&[hidden]) {
        margin-block-start: var(--spacing-3);
    }

    &[hidden] {
        display: none;
    }

    @media screen and (min-width: ${breakpoints.md}) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        grid-template-columns: repeat(4, 1fr);
    }
`;

export const AccessoriesDescription = styled.div`
    grid-column: span 2;
    font-family: var(--font-book);
    font-size: 1.6rem;
    line-height: 2rem;
    color: var(--color-midnight);

    @media screen and (min-width: ${breakpoints.md}) {
        grid-column: span 3;
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        grid-column: span 4;
    }
`;
